import React, { useEffect, useState } from 'react'
import styles from './ModalTheme.module.css'
import Modal from 'react-responsive-modal';
import TabPlan from './Tabs/Plans';
import TabFilesFact from './Tabs/Files_fact';
import TabFilesPlan from './Tabs/Files_plan';
import { useDispatch, useSelector } from 'react-redux';
import { setLessonChart } from '../../../actions/classbook';

const TABS = ['Основная часть', 'Файлы', 'Пояснительная записка', 'Список литературы'];

const ModalTheme = ({ modalData, closeModal, formData }) => {

  const dispatch = useDispatch();
  const { lessons } = useSelector(state => state.classbook);

  const [selectedTab, setSelectedTab] = useState(0);
  const [lessonEntry, setLessonEntry] = useState({ typeid: '', selectedTopic: null, amount: 1, comment: '', dateByFact: '' });

  useEffect(() => {
    setSelectedTab(0);
    setLessonEntry({ typeid: '', selectedTopic: null, amount: 1, comment: '', dateByFact: '' });
  }, [modalData]);

  const handleSave = async () => {
    await dispatch(setLessonChart(modalData, formData, {
      hwtext: '',
      lessonEntries: [{ ...lessonEntry, selectedTopics: lessonEntry.selectedTopic ? [lessonEntry.selectedTopic] : [] }]
    }));
    closeModal();
  };

  const handleClear = () => {
    setLessonEntry({ typeid: '', selectedTopic: null, amount: 1, comment: '', dateByFact: '' });
  };

  const subjectName = lessons?.find(l => l.cid == formData?.lesson)?.title || '';

  const renderTab = () => {
    switch (selectedTab) {
      case 0:
        return (
          <TabPlan
            modalData={modalData}
            formData={formData}
            subjectName={subjectName}
            lessonEntry={lessonEntry}
            setLessonEntry={setLessonEntry}
          />
        );
      case 1:
        return <TabFilesFact formData={formData} modalData={modalData} />;
      case 2:
        return <div style={{ padding: '16px', color: '#85939f' }}>Пояснительная записка</div>;
      case 3:
        return <div style={{ padding: '16px', color: '#85939f' }}>Список литературы</div>;
      default:
        return null;
    }
  };

  return (
    <Modal
      open={!!modalData}
      onClose={closeModal}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={1}
      classNames={{ modal: styles.reportModal }}
    >
      {/* Шапка */}
      <div className={styles.modalHeader}>
        <span className={styles.modalTitle}>Тема занятия</span>
        <button className={styles.closeBtn} onClick={closeModal}>×</button>
      </div>

      {/* Вкладки */}
      <div className={styles.tabsBlock}>
        {TABS.map((t, i) => (
          <div
            key={i}
            className={selectedTab === i ? styles.activeTab : styles.tab}
            onClick={() => setSelectedTab(i)}
          >
            {t}
          </div>
        ))}
      </div>

      {/* Контент */}
      <div className={styles.tabContent}>
        {renderTab()}
      </div>

      {/* Кнопки */}
      <div className={styles.footer}>
        <button className={styles.clearBtn} onClick={handleClear}>
          ✕ Очистить тип и тему занятия
        </button>
        <div className={styles.spacer} />
        <button className={styles.saveBtn} onClick={handleSave}>Сохранить</button>
        <button className={styles.cancelBtn} onClick={closeModal}>Отмена</button>
      </div>

      {/* Статус */}
      <div className={styles.statusBar}>
        <span>Изменил: {modalData?.teacher_fio || '—'}</span>
        <span>Дата изменения: {modalData?.lessonfulldate || '—'}</span>
      </div>
    </Modal>
  );
};

export default ModalTheme;
